import { BaseClass } from 'digicon-events-base';
import { FormsData } from 'project/js/formsData';

export class FormContainer extends BaseClass {

    constructor(properties) {
        super();
        this.container = properties.container;
        this.modules = properties.modules;
        this.formsData = new FormsData(this.container, properties.locale);
    }

    setFormsData(data) {
        this.formsData.setData(data);
    }

    clear() {
        this.formsData.clear();
    }

    update() {
        this.createForms();
        document.querySelectorAll(`#${this.container} .inputForm`).forEach(e => e.remove());
        this.trigger('onFormUpdated', this);
    }

    show(isVisible) {
        document.getElementById(this.container).style.display = isVisible ? 'block' : 'none';
    }

    createForms() {}

    setFieldValue(fieldId, value) {
        this.formsData.setDataFieldValue(fieldId, value);
    }

    getFieldValue(fieldId) {
        return this.formsData.getFormFieldValue(fieldId);
    }

    setFormFieldValue(fieldId, value) {
        this.formsData.setDataFieldValue(fieldId, value);
    }

    getFormData() {
        return this.formsData.getFormData();
    }
}